import { Flex, Group, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import type { FC } from "react";
import type { TabType } from "../../interfaces";

interface MenuProps {
  navigationItems: { label: string; icon: FC }[];
  tabSelectionHandler: (tab: TabType) => void;
}

const Menu: FC<MenuProps> = ({ navigationItems, tabSelectionHandler }) => {
  const { t } = useTranslation();

  if (!navigationItems) return null;

  return (
    <Flex direction="column" gap="sm" style={{ width: "100%" }}>
      {navigationItems.map((item) => {
        if (item.label === "logout") return null;
        const Icon = item.icon;

        return (
          <Group
            key={`ProfileModal_${item.label}_KEY`}
            gap="lg"
            py="xs"
            wrap="nowrap"
            onClick={() => tabSelectionHandler(item.label as TabType)}
            style={{ cursor: "pointer" }}
          >
            <Icon />
            <Text component="span">{t(`profile.navLinks.${item.label}`)}</Text>
          </Group>
        );
      })}
    </Flex>
  );
};

export default Menu;
